import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App as AntdApp, ConfigProvider } from "antd";
import zhCN from "antd/locale/zh_CN";
import { AuthProvider } from "./auth";
import App from "./App";
import "./styles.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ConfigProvider
      locale={zhCN}
      theme={{
        token: {
          colorPrimary: "#ba251e",
          colorInfo: "#ba251e",
          colorBgLayout: "#f5f3f2",
          colorText: "#1f1a17",
          borderRadius: 10,
          borderRadiusLG: 14,
          fontFamily:
            'Inter, "PingFang SC", "Microsoft YaHei", system-ui, sans-serif',
        },
        components: {
          Layout: {
            siderBg: "#1f1a17",
            headerBg: "#ffffff",
          },
          Menu: {
            darkItemBg: "#1f1a17",
            darkItemSelectedBg: "#ba251e",
            darkItemSelectedColor: "#ffffff",
            darkItemHoverBg: "#382e29",
          },
          Card: {
            headerBg: "transparent",
          },
        },
      }}
    >
      <AntdApp>
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </AntdApp>
    </ConfigProvider>
  </StrictMode>,
);
